const wrapper = "_araw6tegte";
const closeButton = "_aracn4yg13";
const list = "_aral6pcmky";

export { closeButton, list, wrapper };
import "./menu.style.linaria.module.css";
//# sourceMappingURL=menu.style.js.map
